import { HIGHEST_VOLUME, HIGHEST_VOLUME_STREAM, } from "../../../interface/drivingMarket/highestVolume/highestVolume";
import { drivingMarketOptionsStream } from "@domains/features/Markets/Options/utils/streamUpdate";
let initState = {
    data: {},
};
const HighestVolume = (state = initState, action) => {
    switch (action.type) {
        case HIGHEST_VOLUME:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case HIGHEST_VOLUME_STREAM:
            return Object.assign(Object.assign({}, state), { data: drivingMarketOptionsStream(state.data, action.payload.qouteStream) });
        default:
            return state;
    }
};
export default HighestVolume;
